var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-alt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M23.625 23.625L17.775 17.775M20.25 11.8125C20.25 13.4813 19.7552 15.1126 18.828 16.5001C17.9009 17.8877 16.5831 18.9691 15.0414 19.6077C13.4996 20.2463 11.8031 20.4134 10.1664 20.0879C8.52971 19.7623 7.0263 18.9587 5.84629 17.7787C4.66628 16.5987 3.86269 15.0953 3.53713 13.4586C3.21157 11.8219 3.37866 10.1254 4.01727 8.58361C4.65588 7.04186 5.73734 5.7241 7.12488 4.79698C8.51242 3.86985 10.1437 3.375 11.8125 3.375C14.0503 3.375 16.1964 4.26395 17.7787 5.84629C19.3611 7.42862 20.25 9.57474 20.25 11.8125Z",
    stroke: "#59B8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.658c78ea948171998f09eb8f334f484d.svg";
export { ForwardRef as ReactComponent };